import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import arrowIcon from '../../../assets/images/matchmaker-arrow.svg';
import readMoreDots from '../../../assets/images/readmore-dots.svg';
import closeIcon from '../../../assets/images/matchmaker-close.svg';

/**
 * Step 1 of the "Be a Matchmaker" flow.
 * Figma: "Match Maker Home Page" (6:81) + "Match Maker Home Page - Popup" (6:309)
 *
 * The popup carries a close button that frame 6:309 does not show — without it
 * the only way out is the backdrop or Esc, which is undiscoverable.
 */
const GiftLandingComponent = ({ goToNextStep }) => {
  const [modalStatus, setModalStatus] = useState(false);

  const goToNext = () => goToNextStep(2);

  return (
    <>
      <div className="matchmakerWrapper mm-landing">
        <div className="mm-content">
          <h1 className="mm-title">
            We All Deserve
            <br />
            Love &amp; Happiness
          </h1>

          <p className="mm-para">
            Wouldn’t it be wonderful if everyone could find true love? We
            certainly think it would be nothing short of magical! At Lovrican,
            we’ve made it easy for you to be the matchmaker for your friends
            and relatives (your kids, cousins, nieces, nephews, etc.). Simply
            become a matchmaker and kickstart their love journey.
          </p>

          <p className="mm-para">
            Here’s how it works: When you play matchmaker for someone special,
            we will take it from there! We’ll reach out to the lucky recipient,
            letting them know about your thoughtful wish of love for them. With
            their enrollment into the Lovrican community...
          </p>

          <button
            type="button"
            className="mm-readmore"
            onClick={() => setModalStatus(true)}
          >
            <span className="mm-readmore-pill">
              <img src={readMoreDots} alt="" />
            </span>
            <span className="mm-readmore-text">READ MORE</span>
          </button>

          <div className="mm-actions">
            <button
              type="button"
              className="mm-next"
              aria-label="Continue"
              onClick={goToNext}
            >
              <img src={arrowIcon} alt="" />
            </button>
          </div>
        </div>
      </div>

      <Modal
        className="matchmaker-readmore"
        backdropClassName="matchmaker-backdrop"
        show={modalStatus}
        onHide={() => setModalStatus(false)}
        centered
      >
        {/* Outside Modal.Body: that element is the scroll container and is
            position: relative, so a button inside it scrolls out of view. */}
        <button
          type="button"
          className="mm-popup-close"
          aria-label="Close"
          onClick={() => setModalStatus(false)}
        >
          <img src={closeIcon} alt="" />
        </button>
        <Modal.Body>
          <h2 className="mm-popup-title">
            We All Deserve
            <br />
            Love &amp; Happiness
          </h2>
          <p className="mm-popup-para">
            Here’s how it works: When you play matchmaker for someone special,
            we will take it from there! We’ll reach out to the lucky recipient,
            letting them know about your thoughtful wish of love for them. With
            their enrollment into the Lovrican community, we’ll connect them
            with some amazing matches tailored to their preferences.
          </p>
          <p className="mm-popup-para">
            Who knows, your small gesture may just lead to a love story that
            lasts a lifetime!
          </p>
          <p className="mm-popup-para">
            And here’s the best part – The more people you inspire to begin
            their search for their special someone, the greater your impact.
            Become a matchmaker today and join us in spreading the magic of
            love! Let’s make the world a brighter and more love-filled place,
            one connection at a time.
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GiftLandingComponent;
